export default __webpack_public_path__ + "static/media/bishop_black.629fc057.svg";